import IState from '../models/IState';
import { createSelector } from "reselect";
import { addUserInitialState } from '../state/user.state';

//const dateFormat = 'YYYY/MM/DD';

const stateAllUsers = (state: IState) => state.user.userList.users;
const stateUserId = (state: IState) => state.auth.userId;
const stateUserType = (state: IState) => state.auth.userType;
const stateUserName = (state: IState) => state.auth.userName;
const getUser = (state: IState) => state.user.user.user;
const stateAllDevice = (state: IState) => state.user.userDevices;

export const allUsers = createSelector(
    stateAllUsers,
    stateUserId,
    stateUserType,
    stateUserName,
    (users, userId, userType, userName) => {
        if (users.Users && users.Users.length > 0)
            return users.Users.map((user: any) => {
                //console.log(userType);
                let isDelete = true;
                //<ARIF> The type of userType shown here is Number, while numeric comparison does not work
                //       Also, if I print or check in Debugger it tells me its String but here I have to convert
                let isEdit = userType.toString() === 'Administrator';
                let isChangePassword = userType.toString() === 'Administrator';
                if (user.UserName === userName || user.IsAssociated) {
                    isDelete = false;
                    //isEdit = true;
                    //isChangePassword = true;
                }
                if (user.UserName === 'admin@test.com' || user.UserName === userName) {
                    isDelete = false;
                    isEdit = false;
                    isChangePassword = false
                }
                return {
                    id: user.Id,
                    UserName: user.UserName,
                    UserType: user.UserType,
                    Email: user.Email,
                    isDelete: isDelete,
                    isEdit: isEdit,
                    isChangePassword: isChangePassword
                }
            })
        return [];
    }
)

export const getUserSelector = createSelector(
    getUser,
    (user) => {
        let finalUser = JSON.parse(JSON.stringify(addUserInitialState));
        if (user != null) {
            finalUser.UserName = user.UserName;
            finalUser.UserType = user.UserType === 'Administrator' ? true : false;
            // finalUser.UserType = user.UserType === 'Administrator' ? 0 : 1;
            finalUser.Email = user.Email;
            finalUser.Password = user.Password;
            finalUser.ConfirmPassword = user.ConfirmPassword;
            finalUser.TimezoneId = user.TimezoneId;
        }
        return finalUser;
    }
)

export const GetDeviceUserDetailsByUserId = createSelector(
    stateAllDevice,
    (devices) => {
        if(devices!==null) return devices
    }
)